import {TextInputEnum} from '../../../../utilities/validation/InputValidation';

export enum BusinessWorkOrderSystemStep {
  SelectCompany = 'SelectCompany',
  Dashboard = 'Dashboard',
  WorkOrderTypeSelecting = 'WorkOrderTypeSelecting',
  WorkOrderForm = 'WorkOrderForm',
  WorkOrderConfirmation = 'WorkOrderConfirmation',
  GeneralMessage = 'GeneralMessage',
  WorkOrderCreationSuccedded = 'WorkOrderCreationSuccedded',
  ReopenWorkOrder = 'ReopenWorkOrder',
}
export enum BusinessWorkOrderSystemPopup {
  WorkOrderData = 'WorkOrderData',
  CloseFU = 'CloseFU',
  GeneralMessage = 'GeneralMessage',
}

export enum GenericInputType {
  String = 'String',
  Number = 'Number',
  DateTime = 'DateTime',
  Dropdown = 'Dropdown',
  IDNumber = 'IDNumber',
  TextArea = 'TextArea',
  Subscriber = 'Subscriber',
  Address = 'Address',
  None = 'None',
  RadioButton = 'RadioButton',
  BAN = 'BAN',
  SubNiud = 'SubNiud',
  CheckBox = 'CheckBox',
  PricePlan = 'PricePlan',
  Sim = 'Sim',
  File = 'File',
}

export enum StayInformedChoiceEnum {
  NO = 'NO',
  MAIL = 'MAIL',
  SMS = 'SMS',
}

export const GenericInputTypeDef: {
  [key: string]: {
    type: string;
    requiresAdditionalValidation?: boolean;
    inputValidationType?: string;
    displayButtonValidation?: boolean;
  };
} = {
  String: {
    type: GenericInputType.String,
    inputValidationType: TextInputEnum.String,
  },
  Number: {
    type: GenericInputType.Number,
    inputValidationType: TextInputEnum.Number,
  },
  DateTime: {
    type: GenericInputType.DateTime,
    inputValidationType: TextInputEnum.Date,
  },
  Dropdown: {
    type: GenericInputType.Dropdown,
  },
  IDNumber: {
    type: GenericInputType.IDNumber,
    inputValidationType: TextInputEnum.Id,
  },
  Subscriber: {
    type: GenericInputType.Subscriber,
    inputValidationType: TextInputEnum.PhoneExtended,
    requiresAdditionalValidation: true,
  },
  TextArea: {
    type: GenericInputType.TextArea,
  },
  Address: {
    type: GenericInputType.Address,
  },
  RadioButton: {
    type: GenericInputType.None,
  },
  BAN: {
    type: GenericInputType.BAN,
  },
  PricePlan: {
    type: GenericInputType.PricePlan,
  },
  SubNiud: {
    type: GenericInputType.SubNiud,
    inputValidationType: TextInputEnum.PhoneExtended,
    requiresAdditionalValidation: true,
  },
  Sim: {
    type: GenericInputType.Sim,
    inputValidationType: TextInputEnum.Sim,
    requiresAdditionalValidation: true,
  },
  CheckBox: {
    type: GenericInputType.CheckBox,
  },
  None: {
    type: GenericInputType.None,
  },
  File: {
    type: GenericInputType.File,
    inputValidationType: TextInputEnum.None,
  },
};

export const DeviceRepairCsvHeaders = [
  'מנוי',
  'מספר סידורי',
  'קוד נעילה קיים',
  'קוד נעילה',
  'מכשיר חלופי נדרש',
  'אישר איפוס תכנים',
  'נושא תקלה-סוג',
];
export const DeviceRepairCsvFields = [
  'subscriber',
  'deviceSerialNumber',
  'securityCodeExist',
  'securityCode',
  'alternatePhoneRequired',
  'clearContentApproved',
  'causeList',
];

export const initialDeviceRepairIssue = {
  selectedCauseType: '',
  selectedCauseSubType: '',
};

export const generalRadioInputOptions = [
  {value: false, key: 'לא'},
  {value: true, key: 'כן'},
];

export const radioInputOptions = [
  {name: 'alternatePhoneRequired', title: 'האם לספק מכשיר חלופי?', options: generalRadioInputOptions},
  {name: 'securityCodeExist', title: 'האם קיים קוד נעילה?', options: generalRadioInputOptions},
];

export const fileExtensions = {
  pdf: 'pdf',
  png: 'png',
  xls: 'xls',
  jpg: 'jpg',
};

export const ParamsNeedingExtendedData = [GenericInputType.PricePlan];
export const ParamsNeedingAdditionalValidation = [GenericInputType.Subscriber, GenericInputType.Sim];
export const SUBNAME_PARAM_CODE = 'SUBNAME';
export const errorMessages = {
  anotherValidation: 'בכדי להמשיך יש לבצע בדיקה',
};

const brandNameHe = () => window.Config?.brand_Name_HE ?? '';

export const MessageContent = {
  GeneralError: {
    icon: require('../Icons/error.svg'),
    title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    secondTitle: 'באפשרותך לנסות שוב או לפנות לאחראי השירות',
    secondButtonText: 'לאזור האישי',
    secondButtonClick: 'businessLobby',
  },
  SuccessPage: {
    icon: require('../Icons/success.svg'),
    title: 'פניה מספר {workOrderNumber} נפתחה בהצלחה לצוותן השירות',
    secondTitle: 'הפניה תטופל עד {expirationData} צוותן שירות בית לקוח איכילוב',
    get subTitle() {
      return `לרשותך בכל דבר, ${brandNameHe()} עסקים`;
    },
    buttonText: 'לניהול הפניות שלי',
    buttonClick: 'setCurrentStep',
    secondButtonText: 'חזרה לאזור האישי',
    secondButtonClick: 'businessLobby',
  },
};
